type Female = "f";
type Male = "m";

export type Gender = Female | Male;

export function formatGender(gender: Gender) {
  return gender === "f" ? "0.1" : "1.0";
}
